module.exports = __webpack_public_path__ + "42a32005be5a8638eb6ad2dba6939aff.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-31.png
// module id = 1802
// module chunks = 0